import { render, staticRenderFns } from "./o-site-header.vue?vue&type=template&id=23658f12"
import script from "./o-site-header.vue?vue&type=script&lang=js"
export * from "./o-site-header.vue?vue&type=script&lang=js"
import style0 from "./o-site-header.vue?vue&type=style&index=0&id=23658f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports